import React, { useEffect } from 'react';

export function YaFloorAd({ blockId }) {
    console.log("YaFloorad:", blockId)
    useEffect(() => {
        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.render({
                blockId,
                type: 'floorAd',
                platform: 'touch',
            });
        });
    }, []);

    return null;
}
